import React from 'react';

import TableFilterInput from '../../../../../../components/table/TableFilterInput';
import { addAllItemToSelectList, setColumnWidth, setDash } from '../../../../../../lib/common';
import Anchor from '../../../../../../components/link/Anchor';
import CouponBenefit from '../../../../../coupon/common/CouponBenefit';
import Select from '../../../../../../components/input/Select/Select';
import {
  COUPON_AVAILABLE_TYPE_TEXT,
  COUPON_DISCOUNT_TYPE_SELECT_LIST,
  MAXIMUM_NUMBER_OF_COUPON_ISSUED_COUNT,
  MINIMUM_NUMBER_OF_COUPON_ISSUED_COUNT,
} from '../../../../../../constants/service/app/couponConstants';
import InputNumber from '../../../../../../components/input/InputNumber/InputNumber';
import CouponBenefitInfo from '../../../../../coupon/common/CouponBenefitInfo';
import { setDateFormat } from '../../../../../../lib/moment';
import { DATE_FORMAT } from '../../../../../../constants/service/common/utilConstants';
import DateRangePicker from '../../../../../../components/datePicker/DateRangePicker';
import CouponPeriod from '../../../../../coupon/common/CouponPeriod';

/**
 *  쿠폰 리스트 컬럼
 */
const columns = (data) => {
  const { list, filterOption, toggleModal, onFilter, onChangeIssuedCount } = data;

  return [
    {
      accessor: 'couponId',
      Header: '쿠폰 번호',
      resizable: true,
      filterable: true,
      fixed: 'left',
      width: 80,
      Filter: () => <TableFilterInput option={filterOption.couponId} onFilter={(couponId) => onFilter({ couponId })} />,
    },
    {
      accessor: 'couponName',
      Header: '쿠폰명',
      className: 'align-left',
      resizable: true,
      filterable: true,
      fixed: 'left',
      width: setColumnWidth(list, 'couponName'),
      Cell: (row) => (
        <Anchor
          isUnderLine
          color="primary"
          onClick={() =>
            toggleModal({
              name: 'couponDetailModal',
              value: true,
              data: {
                couponDetail: row.original,
              },
            })
          }
          text={`${row.original.couponName}`}
        />
      ),
      Filter: () => (
        <TableFilterInput option={filterOption.couponName} onFilter={(couponName) => onFilter({ name: couponName })} />
      ),
    },
    {
      accessor: 'description',
      Header: '쿠폰 설명',
      className: 'align-left',
      resizable: true,
      filterable: true,
      fixed: 'left',
      width: 200,
      Cell: (row) => setDash(row.value),
      Filter: () => (
        <TableFilterInput option={filterOption.description} onFilter={(description) => onFilter({ description })} />
      ),
    },
    {
      accessor: 'discountType',
      Header: '쿠폰 혜택',
      filterable: true,
      fixed: 'left',
      width: 120,
      Cell: (row) => <CouponBenefit type={row.value} amount={row.original.discountAmount} />,
      Filter: () => (
        <Select
          list={addAllItemToSelectList(COUPON_DISCOUNT_TYPE_SELECT_LIST)}
          onChange={(discountType) => onFilter({ discountType })}
          defaultValue={filterOption.discountType}
          value={filterOption.discountType}
          isTable={true}
          size="large"
        />
      ),
    },
    {
      accessor: 'code',
      Header: '코드',
      filterable: true,
      fixed: 'left',
      width: 100,
      Cell: (row) => setDash(row.value),
      Filter: () => <TableFilterInput option={filterOption.code} onFilter={(code) => onFilter({ code })} />,
    },
    {
      Header: '발급 갯수',
      fixed: 'left',
      width: 120,
      Cell: (row) => (
        <InputNumber
          min={MINIMUM_NUMBER_OF_COUPON_ISSUED_COUNT}
          max={MAXIMUM_NUMBER_OF_COUPON_ISSUED_COUNT}
          value={row.original.issuedCount}
          onChange={(value) => {
            onChangeIssuedCount(row.index, value);
          }}
        />
      ),
    },
    {
      accessor: 'availableType',
      Header: '쿠폰 유형',
      width: 100,
      Cell: (row) => COUPON_AVAILABLE_TYPE_TEXT[row.value] || '_',
    },
    {
      Header: '쿠폰 혜택 정보',
      resizable: true,
      width: 160,
      Cell: (row) => (
        <CouponBenefitInfo
          type={row.original.discountType}
          amount={row.original.discountAmount}
          minimumPurchasePrice={row.original.minimumPurchasePrice}
          maxDiscountPrice={row.original.maxDiscountPrice}
        />
      ),
    },
    {
      accessor: 'createDate',
      Header: '생성일자',
      sortable: true,
      filterable: true,
      width: 320,
      Cell: (row) => setDateFormat(row.value, DATE_FORMAT.YMD_DASH_FORMAT),
      Filter: () => (
        <DateRangePicker
          value={filterOption.createDate}
          outFormat={DATE_FORMAT.YMD_DASH_FORMAT}
          onSelect={(data) => onFilter({ createDate: data })}
        />
      ),
    },
    {
      Header: '사용기간',
      width: 290,
      Cell: (row) => (
        <CouponPeriod
          type={row.original.periodType}
          startDate={row.original.startDate}
          endDate={row.original.endDate}
          dayPlus={row.original.dayPlus}
        />
      ),
    },
    {
      accessor: 'memo',
      Header: '메모',
      className: 'align-left',
      resizable: true,
      width: 200,
    },
  ];
};

export default columns;
